import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "caption-normal-text" };
import { computed, onMounted, ref, } from 'vue';
import { useOptionList, validationLimitingValue, } from '@/constants';
import { makeFormDataComputed, makeNumberTypeFormDataComputed, setFormData, } from '@/utils/vueUtils';
import { i18n } from '@/locales';
import InputRow from '@/components/Form/InputRow.vue';
import { useRoute } from 'vue-router';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShareConfigBasic',
    props: {
        lc: {
            type: String,
            default: '',
        },
        formRules: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(__props) {
        const props = __props;
        const route = useRoute();
        const { lc } = props;
        const hubName = ref('');
        const { SHARE_DELAY_SECOND_TEXT_FIELD_MAX_LENGTH, } = validationLimitingValue;
        const formData = computed(() => vuexStore.state.shareManagement.shareConfig.formData);
        const formattedShareDelaySecondComputed = makeNumberTypeFormDataComputed(formData.value, 'shareDelaySecond');
        const handleBlurShareDelaySecondField = (value) => {
            if (value === null) {
                setFormData(formData.value, 'shareDelaySecond', 0);
            }
        };
        const isDisplayedOnOrderComputed = makeFormDataComputed(formData.value, 'isDisplayedOnOrder');
        const localeInfo = {
            agencyHubId: {
                label: i18n.t(`${lc}agency_hub_name`),
            },
            shareDelaySecond: {
                info: i18n.t(`${lc}share_delay_second_possible_input_info_text`),
                suffix: i18n.t('unit.second'),
                label: i18n.t(`${lc}share_delay_second`),
            },
            isDisplayedOnOrder: {
                label: i18n.t(`${lc}is_displayed_on_order`),
                optionLabel: (label) => label,
            },
        };
        onMounted(() => {
            // 수주 허브명 정책 - default는 목록페이지에서 선택한 수주허브: https://barogo.slack.com/archives/C04UP4VFCKA/p1706061536667239?thread_ts=1706060446.850309&cid=C04UP4VFCKA
            const { agencyHubId } = route.params;
            hubName.value = agencyHubId;
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            return (_openBlock(), _createElementBlock("div", null, [
                _createCommentVNode(" 공유시간 "),
                _createVNode(InputRow, {
                    label: localeInfo.shareDelaySecond.label
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "mb-1",
                            modelValue: _unref(formattedShareDelaySecondComputed),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(formattedShareDelaySecondComputed) ? (formattedShareDelaySecondComputed).value = $event : null)),
                            outlined: "",
                            "hide-details": "auto",
                            inputmode: "numeric",
                            variant: "outlined",
                            density: "compact",
                            "validate-on": "blur",
                            suffix: localeInfo.shareDelaySecond.suffix,
                            maxlength: _unref(SHARE_DELAY_SECOND_TEXT_FIELD_MAX_LENGTH),
                            rules: __props.formRules.shareDelaySecond.value,
                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                            onBlur: _cache[1] || (_cache[1] = ($event) => (handleBlurShareDelaySecondField(formData.value.shareDelaySecond)))
                        }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength", "rules"]),
                        _createElementVNode("span", _hoisted_1, _toDisplayString(localeInfo.shareDelaySecond.info), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 접수 목록 공유 "),
                _createVNode(InputRow, {
                    label: localeInfo.isDisplayedOnOrder.label
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _unref(isDisplayedOnOrderComputed),
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(isDisplayedOnOrderComputed) ? (isDisplayedOnOrderComputed).value = $event : null)),
                            name: "radio",
                            inline: "",
                            dense: "",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useOptionList), (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: localeInfo.isDisplayedOnOrder.optionLabel(option.label),
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"])
            ]));
        };
    }
});
